<template>
  <div class="choose-level-tabs">
    <div
      v-for="item in list"
      :key="item.key"
      class="item"
      :class="[activeKey === item.key ? 'active' : '']"
      @click="changeTab(item)"
    >
      {{ item.title }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          title: this.$t('hsk_levels'),
          key: 'hsk_levels',
        },
        {
          title: this.$t('hsk_speaking'),
          key: 'hsk_speaking',
        },
        {
          title: this.$t('yct'),
          key: 'yct',
        },
      ],
      activeKey: 'hsk_levels',
    }
  },
  emits: ['changeTab'],
  methods: {
    changeTab(item) {
      this.activeKey = item.key
      this.$emit('changeTab', item.key)
    },
  },
}
</script>

<style lang="scss">
.choose-level-tabs {
  background: #fff;
  height: 70px;
  display: flex;
  justify-content: center;
  box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.1);

  & > .item {
    height: 100%;
    padding: 0 20px;
    line-height: 70px;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;

    &.active {
      background: #e5e7eb;
    }
  }
}

@media (max-width: 768px) {
  .choose-level-tabs {
    & > .item {
      width: 33.33%;
      text-align: center;
      font-size: 14px;
      padding: 0;
    }
  }
}
</style>
